import './index.scss'

$('.question-list').on('click','li .item-title',function(){
  let $parentsEl = $(this).parents('li')
  if($parentsEl.hasClass('active')){
    if($(window).width() > 767){
      $parentsEl.removeClass('active').find('.item-desc').slideUp()
    }else{
      $parentsEl.removeClass('active')
      $('.job-mask').fadeOut(400)
    }
  }else{
    if($(window).width() > 767){
      $parentsEl.addClass('active').find('.item-desc').slideDown()
      $parentsEl.siblings().removeClass('active').find('.item-desc').slideUp()
    }else{
      $parentsEl.addClass('active').siblings().removeClass('active')
      $('.job-mask').fadeIn(400)
    }
  }
})

$(document).ready(function(){
  // 移动端显示选择项
  $('.show-select').on('click',function(){
    $('.mob-select').addClass('active')
    $('.job-mask').fadeIn(400)
  })
  $('.mob-select .mob-btn >div').on('click',function(){
    $('.mob-select').removeClass('active')
    $('.job-mask').fadeOut(400)
  })
  $('.job-mask').on('click',function(){
    $('.mob-select').removeClass('active')
    $('.question-list li').removeClass('active')
    $('.job-mask').fadeOut(400)
  })
  $('.question-list').on('click','li .mob-close',function(){
    $('.question-list li').removeClass('active')
    $('.job-mask').fadeOut(400)
  })
})